module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_3_ECOSISTÉMICO.e89a25b7.jpg";